import { ReactNode } from "react";
import { Link } from "react-router-dom";

type UnderwritingUiPageShellProps = {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  children: ReactNode;
};

export default function UnderwritingUiPageShell({
  title,
  subtitle,
  backTo,
  backLabel = "Back",
  children,
}: UnderwritingUiPageShellProps) {
  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "12px 16px", borderBottom: "1px solid #e5e5e5" }}>
        {backTo && (
          <Link to={backTo} style={{ display: "inline-block", marginBottom: 8 }}>
            ← {backLabel}
          </Link>
        )}
        <h4 style={{ margin: 0 }}>{title}</h4>
        {subtitle && <small className="text-muted">{subtitle}</small>}
      </div>
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        {children}
      </div>
    </div>
  );
}
